"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
var Logger = /** @class */ (function () {
    function Logger(transporters) {
        this.transporters = transporters;
    }
    Logger.prototype.log = function (logData) {
        this.transporters.forEach(function (transporter) { return transporter.log(logData); });
    };
    Logger.prototype.dispose = function () {
        this.transporters.forEach(function (transporter) { return transporter.dispose(); });
    };
    return Logger;
}());
exports.Logger = Logger;
//# sourceMappingURL=Logger.js.map